$(function(){

    //rating on search/hub page - create stars spans for UI
    function ratingStars(rating, showZeroRating) {
        var rating = Math.min(Math.max(rating, 0.0), 5.0);
        // Convert to half stars
        rating = (rating * 2).toFixed(0) / 2;

        var ratingParts = rating.toString().split('.');
        var firstPart = parseInt(ratingParts[0], 10);
        var lastPart = parseInt(ratingParts[1], 10);

        var half = '<i class="fa fa-star-half-o"></i>';
        var full = '<i class="fa fa-star"></i>';
        var empty = '<i class="fa fa-star-o"></i>';
        var stars = '';

        //full star
        for(var i=0;i<firstPart;i++) {
            stars += full;
        }

        // TODO remove 'true ||' if we want to hide zero ratings on cards
        if ((true || showZeroRating || firstPart > 0) && firstPart < 5) {
            //half
            if(isNaN(lastPart) || lastPart < 5) {
                stars += empty;
            }
            else if(lastPart > 5) {
                stars += full;
            }
            else if(lastPart === 5) {
                stars += half;
            }

            //empty
            for(var i=0;i<(5-firstPart-1);i++) {
                stars += empty;
            }
        }

        return stars;
    }

    function applyRating() {
        $('.js-rating').each(function(){
            var $this = $(this);
            var ratingText = $this.text();
            var $overallRating = $('<span class="hidden">' + ratingText + '</span>');
            if ($this.hasClass('emit-itemprop')) {
                $overallRating.attr('itemprop', 'ratingValue');
            }
            $this
                .addClass('Rating')
                .html(ratingStars(ratingText, $this.hasClass('show-zero-rating'))) //replace all inner content with stars
                .prepend($overallRating); //add text rating inside

            // For testing, disable above prepend line and enable following
            // var one = Math.floor(Math.random() * 4) + 1;
            // var two = Math.floor(Math.random() * 5) + 1;
            // var num = one + '.' + two;
            // $this.html( ratingStars(num) + num );
        });
    }

    applyRating();

    //bind it to body so can be called from any where
    $('body').bind('TES:applyRating', applyRating);
    $('body').bind('TES:applyRatingStars', applyRating);
});